import React from 'react';

const Impressum = () => {
  return (
    <div className="page-container">
      <section className="page-hero">
        <div className="section-container">
          <h1 className="page-title">Impressum</h1>
        </div>
      </section>

      <section className="page-content">
        <div className="section-container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h2 className="subsection-title">Angaben gemäß § 5 TMG</h2>
            <p className="text-content">
              Physiotherapie Grau<br />
              Rosestraße 4<br />
              99510 Apolda
            </p>

            <h3 className="subsection-subtitle">Kontakt</h3>
            <p className="text-content">
              Telefon: 03644 515313<br />
              E-Mail: physio.grau@gmail.com
            </p>

            <h3 className="subsection-subtitle">Berufsbezeichnung und berufsrechtliche Regelungen</h3>
            <p className="text-content">
              Berufsbezeichnung: Physiotherapeut/in (verliehen in Deutschland)
            </p>
            <p className="text-content">
              Zuständige Kammer:<br />
              Deutscher Verband für Physiotherapie (ZVK) e.V.<br />
              Kölner Str. 205<br />
              50321 Brühl
            </p>

            <h3 className="subsection-subtitle">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h3>
            <p className="text-content">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>

            <h3 className="subsection-subtitle">Haftung für Inhalte</h3>
            <p className="text-content">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen 
              Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind 
              wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte 
              fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
              rechtswidrige Tätigkeit hinweisen.
            </p>

            <h3 className="subsection-subtitle">Haftung für Links</h3>
            <p className="text-content">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir 
              keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine 
              Gewähr übernehmen.
            </p>

            <h3 className="subsection-subtitle">Urheberrecht</h3>
            <p className="text-content">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten 
              unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, 
              Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
              bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Impressum;